import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
import { Input, Modal, Button, Icon } from "@h3/antd-vue";
// import { MapModal } from './map-modal.vue';
let SmartLocation = class SmartLocation extends Vue {
    // import { MapModal } from './map-modal.vue';
    constructor() {
        super(...arguments);
        // @Prop({
        //   type: Boolean,
        //   default: false
        // })
        // visible!: boolean;
        // mounted() {
        //   this.events = {
        //     click: this.onClickMap
        //   };
        // }
        // events: any = null;
        // address: string = "";
        // lng: number = 0;
        // lat: number = 0;
        // adcode: String = "";
        this.showMap = false;
        // openTip: boolean = true;
        // searchKey: string = '';
        // searchOption: any = {
        //   city: "",
        //   citylimit: false
        // };
        // isInit: boolean = true;
        // loaded = false;
        // timestamp: number = 0;
        // mapCenter: Array<number> = [121.59996, 31.197646];
        // marker: number[] = this.mapCenter;
        this.hover = false;
        this.address = '';
    }
    // geolocation: any;
    // showSearchResult = false;
    // get vidMap() {
    //   return `${this.vid}-${this.timestamp}`;
    // }
    focus(e) {
        if (this.disabled) {
            return false;
        }
        if (this.initMap) {
            this.initMap().then((vmap) => {
                vmap.lazyAMapApiLoaderInstance.load().then(() => {
                    this.showMap = true;
                });
            });
        }
        // this.showMap = true;
        // if (this.isInit) {
        //   this.isInit = false;
        //   this.gettimestamp();
        // }
        // const vmap = require('vue-amap');
        // vmap.lazyAMapApiLoaderInstance.load().then(()=>{
        //   this.showMap = true;
        // });
    }
    onMouseenter() {
        this.hover = true;
    }
    onMouseleave() {
        this.hover = false;
    }
    clear() {
        const val = {};
        this.onOk(val);
    }
    // calculateDir() {
    //   const bodyHeight = document.body.clientHeight;
    //   const localeHeight = this.$refs.location.clientHeight + this.$refs.location.scrollHeight;
    //   const dir = bodyHeight - localeHeight;
    //   const str = dir > 340 ? '下' : '上'
    //   console.log(str)
    // }
    // gettimestamp() {
    //   this.timestamp = new Date().getTime();
    // }
    get IsSelect() {
        return this.type === 'select';
    }
    onOk(val) {
        this.showMap = false;
        this.$emit("input", val);
        this.$emit("ok", val);
        this.onCancel();
    }
    onCancel() {
        this.showMap = false;
        if (this.$refs.input) {
            this.$refs.input.blur();
        }
    }
    onChange(val) {
        if (val && val.lat && val.lng) {
            this.address = `${val.provinceName || ''}${val.cityName || ''}${val.districtName || ''}${val.address || ''}`;
        }
        else {
            this.address = '';
        }
    }
};
tslib_1.__decorate([
    Model("input")
], SmartLocation.prototype, "value", void 0);
tslib_1.__decorate([
    Prop()
], SmartLocation.prototype, "prefixCls", void 0);
tslib_1.__decorate([
    Prop()
], SmartLocation.prototype, "prefixStyle", void 0);
tslib_1.__decorate([
    Prop()
], SmartLocation.prototype, "selectStyle", void 0);
tslib_1.__decorate([
    Prop({
        type: String,
        default: 'select'
    })
], SmartLocation.prototype, "type", void 0);
tslib_1.__decorate([
    Prop({
        type: String
    })
], SmartLocation.prototype, "vid", void 0);
tslib_1.__decorate([
    Prop({
        type: String,
        default: ''
    })
], SmartLocation.prototype, "placeholder", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: false
    })
], SmartLocation.prototype, "disabled", void 0);
tslib_1.__decorate([
    Prop({
        type: String,
        default: "zh"
    })
], SmartLocation.prototype, "locale", void 0);
tslib_1.__decorate([
    Prop({
        type: Boolean,
        default: false
    })
], SmartLocation.prototype, "showTip", void 0);
tslib_1.__decorate([
    Prop()
], SmartLocation.prototype, "initMap", void 0);
tslib_1.__decorate([
    Watch("value", {
        immediate: true
    })
], SmartLocation.prototype, "onChange", null);
SmartLocation = tslib_1.__decorate([
    Component({
        name: "SmartLocation",
        components: {
            AModal: Modal,
            AInput: Input,
            AButton: Button,
            AIcon: Icon,
            MapModal: () => import('./map-modal.vue')
        }
    })
], SmartLocation);
export default SmartLocation;
